import { render, staticRenderFns } from "./LayoutCard.vue?vue&type=template&id=0205d29a&scoped=true&"
import script from "./LayoutCard.vue?vue&type=script&lang=js&"
export * from "./LayoutCard.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCard.vue?vue&type=style&index=0&id=0205d29a&prod&lang=scss&scoped=true&"
import style1 from "./LayoutCard.vue?vue&type=style&index=1&id=0205d29a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205d29a",
  null
  
)

export default component.exports